import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import reportWebVitals from './reportWebVitals';
import './css_reset.css'
import { Provider as AuthProvider } from './contexts/AuthContext'

// The app shell pins #root to the viewport (height:100vh; overflow:hidden).
// The marketing home page ("/") must scroll, so the lock is gated behind an
// `app-shell` class — NOT the conditional require, because the production build
// extracts all CSS into one always-linked stylesheet (the require guard only
// works in dev). The class is the reliable, build-agnostic gate.
if (window.location.pathname !== '/') {
  require('./index.css')
  document.documentElement.classList.add('app-shell')
}

ReactDOM.render(
  <React.StrictMode>
    <AuthProvider>
      <App />
    </AuthProvider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
